var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpanded = function SvgExpanded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 20v-6a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v6h2v-6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6h2ZM0 0v6a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V0h-2v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V0H0Z",
    fill: "#C4C4C4"
  })));
};
export default SvgExpanded;